import React from 'react';

const FinanceSystem = () => {
    return (
        <div>
            
        </div>
    );
}

export default FinanceSystem;
